<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<div class="p-fluid">
  <app-warehousing-page-header activeSection="shipment-work"
    [title]="!warehouseId ? 'Warehouse Work Detail' :
      workDirection === 'INBOUND' ? 'Inbound Work Detail' : 'Outbound Work Detail'"
    subtitle="Transfers, dispatches, scans, bulk actions, attachments, and history for this record.">
    <div actions class="flex gap-2">
      <p-button [label]="workDirection === 'INBOUND' ? 'Inbound queue' : 'Outbound queue'"
        icon="pi pi-arrow-left" severity="secondary" [outlined]="true"
        [routerLink]="directoryLink()" [queryParams]="directoryParams()"></p-button>
      <p-button label="Dispatches" icon="pi pi-send" severity="secondary" [outlined]="true" routerLink="/warehousing/dispatch"></p-button>
      <p-button label="Transfers" icon="pi pi-sync" severity="secondary" [outlined]="true" routerLink="/warehousing/transfers"></p-button>
    </div>
  </app-warehousing-page-header>

  @if (work) {
    @if (warehouseId) {
      <nav class="flex flex-wrap gap-2 mb-3" aria-label="Warehouse work direction">
        <p-button label="Outbound work" icon="pi pi-sign-out" [outlined]="workDirection !== 'OUTBOUND'"
          (click)="selectWorkDirection('OUTBOUND')"></p-button>
        @if (canViewNotice() || canViewReturn()) {
          <p-button label="Inbound work" icon="pi pi-sign-in" [outlined]="workDirection !== 'INBOUND'"
            (click)="selectWorkDirection('INBOUND')"></p-button>
        }
      </nav>
    }
    <section class="shipment-work-summary">
      <div class="shipment-work-metric">
        <span>Shipment</span>
        <strong>{{ work.shipmentNumber || '-' }}</strong>
      </div>
      <div class="shipment-work-metric">
        <span>Status</span>
        <p-tag [value]="work.shipmentStatus || '-'" [severity]="statusSeverity(work.shipmentStatus)"></p-tag>
      </div>
      <div class="shipment-work-metric">
        <span>Warehouse Docs</span>
        <strong>{{ work.workCount || 0 }}</strong>
      </div>
      <div class="shipment-work-metric">
        <span>Attachments</span>
        <strong>{{ work.attachmentCount || work.attachments.length || 0 }}</strong>
      </div>
      <div class="shipment-work-metric">
        <span>Loading Rule</span>
        <strong>Route Sequenced</strong>
      </div>
    </section>

    @if (shipmentInbounds.length) {
      <section class="warehousing-table-card">
        <div class="warehousing-table-header">
          <div><h2>Shipment inbound cargo</h2><p>Expected cargo appears at shipment creation. Complete its destination stop before issuing a GRN.</p></div>
          <span class="warehousing-result-chip">{{ shipmentInbounds.length }} requests</span>
        </div>
        @for (request of shipmentInbounds; track request.id) {
          <div class="px-3 py-3 border-bottom-1 surface-border">
            <div class="flex flex-wrap align-items-center gap-2 mb-3">
              <strong>{{ request.shipmentNumber }}</strong>
              <p-tag [value]="request.status" [severity]="request.status === 'RECEIVED' ? 'success' :
                request.status === 'EXCEPTION' ? 'danger' : 'info'"></p-tag>
              <span class="text-600">{{ warehouseLabel(request.warehouseId) }}</span>
            </div>
            <div class="overflow-x-auto">
              <table class="w-full" style="min-width: 44rem">
                <thead><tr><th>Item</th><th>Planned</th><th>Eligible</th><th>Status</th><th>GRN</th></tr></thead>
                <tbody>
                  @for (line of request.lines; track line.id) {
                    @if (workType === 'SHIPMENT' || line.deliveryId === workId) {
                    <tr>
                      <td>{{ itemLabel(line) }} <small class="text-600">· Line #{{ line.shipmentLineId }}</small></td>
                      <td>{{ formatQty(line.planned) }}</td><td>{{ formatQty(line.expected) }}</td>
                      <td><p-tag [value]="line.status" [severity]="line.status === 'RECEIVED' ? 'success' :
                        line.status === 'EXCEPTION' ? 'danger' : 'info'"></p-tag></td>
                      <td>@if (line.inboundReceiptId) {
                        <a [routerLink]="['/warehousing/stock-entry/view', line.inboundReceiptId]">{{ line.receiptNumber || ('GRN #' + line.inboundReceiptId) }}</a>
                      } @else { — }</td>
                    </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
            @if (canReceiveReturn() && request.status === 'READY') {
              <div class="flex justify-content-end mt-3">
                <p-button label="Receive with bulk GRN" icon="pi pi-file-check"
                  [routerLink]="['/warehousing/stock-entry/bulk-receive']"
                  [queryParams]="{ shipmentInboundRequestId: request.id }"></p-button>
              </div>
            }
          </div>
        }
      </section>
    }
    @if (returnRequests.length) {
      <section class="warehousing-table-card">
        <div class="warehousing-table-header">
          <div><h2>Shipment returns</h2><p>Expected cargo is visible before arrival. Receive the physical count after the return stop is complete.</p></div>
          <span class="warehousing-result-chip">{{ returnRequests.length }} returns</span>
        </div>
        @for (request of returnRequests; track request.id) {
          <div class="px-3 py-3 border-bottom-1 surface-border">
            <div class="flex flex-wrap align-items-center gap-2 mb-3">
              <strong>Return stop #{{ request.returnStopId }}</strong>
              <p-tag [value]="request.status" [severity]="request.status === 'RECEIVED' ? 'success' :
                request.status === 'BLOCKED' || request.status === 'EXCEPTION' ? 'danger' : 'info'"></p-tag>
              <span class="text-600">{{ warehouseLabel(request.warehouseId) }}</span>
              <small class="text-600">Created {{ request.createdAt ? (request.createdAt | date:'medium') : 'unknown' }}
                by {{ request.createdByActor?.name || 'unknown' }}</small>
            </div>
            @if (request.blocker) { <div class="p-3 mb-3 border-round bg-yellow-50 text-yellow-900" role="alert">{{ request.blocker }}</div> }
            <div class="overflow-x-auto">
              <table class="w-full" style="min-width: 68rem">
                <thead><tr><th>Item / owner</th><th>Expected</th><th>Physical count</th><th>Zone</th>
                  <th>Condition</th><th>Disposition</th><th>Unit codes</th><th>Exception reason</th></tr></thead>
                <tbody>
                  @for (line of request.lines; track line.id) {
                    <tr>
                      <td><strong>{{ itemLabel(line) }}</strong><br>
                        <small>Release #{{ line.releaseId || '—' }} · Client #{{ line.crmClientId || '—' }} · Account #{{ line.crmAccountId || '—' }}</small></td>
                      <td>{{ formatQty(line.expected) }}</td>
                      <td><p-inputGroup><p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                        <p-iftalabel><input [id]="'return-count-' + line.id" type="number" min="0" step="0.0001"
                          pInputText [(ngModel)]="returnDraft[line.id].quantity" [disabled]="request.status !== 'READY'" />
                          <label [for]="'return-count-' + line.id">Received quantity</label></p-iftalabel></p-inputGroup></td>
                      <td><p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                        <p-iftalabel><p-select [inputId]="'return-zone-' + line.id" [options]="returnZones(request)"
                          optionLabel="name" optionValue="id" [(ngModel)]="returnDraft[line.id].zoneId"
                          [disabled]="request.status !== 'READY'" appendTo="body" styleClass="w-full"></p-select>
                          <label [for]="'return-zone-' + line.id">Receipt zone</label></p-iftalabel></p-inputGroup></td>
                      <td><p-inputGroup><p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
                        <p-iftalabel><p-select [inputId]="'return-condition-' + line.id" [options]="conditions"
                          optionLabel="name" optionValue="id" [(ngModel)]="returnDraft[line.id].conditionId"
                          [disabled]="request.status !== 'READY'" appendTo="body" styleClass="w-full"></p-select>
                          <label [for]="'return-condition-' + line.id">Condition</label></p-iftalabel></p-inputGroup></td>
                      <td><p-inputGroup><p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon>
                        <p-iftalabel><p-select [inputId]="'return-disposition-' + line.id"
                          [options]="[{label:'Available',value:'AVAILABLE'},{label:'Hold',value:'HOLD'}]"
                          optionLabel="label" optionValue="value" [(ngModel)]="returnDraft[line.id].disposition"
                          [disabled]="request.status !== 'READY'" appendTo="body" styleClass="w-full"></p-select>
                          <label [for]="'return-disposition-' + line.id">Disposition</label></p-iftalabel></p-inputGroup></td>
                      <td><p-inputGroup><p-inputGroupAddon><i class="pi pi-barcode"></i></p-inputGroupAddon>
                        <p-iftalabel><input [id]="'return-codes-' + line.id" pInputText
                          [(ngModel)]="returnDraft[line.id].unitCodes" [disabled]="request.status !== 'READY'"
                          placeholder="Comma-separated if identified" />
                          <label [for]="'return-codes-' + line.id">Unit codes</label></p-iftalabel></p-inputGroup></td>
                      <td><p-inputGroup><p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon>
                        <p-iftalabel><input [id]="'return-reason-' + line.id" pInputText
                          [(ngModel)]="returnDraft[line.id].exceptionReason" [disabled]="request.status !== 'READY'" />
                          <label [for]="'return-reason-' + line.id">Reason if short or held</label></p-iftalabel></p-inputGroup></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (canReceiveReturn() && request.status === 'READY') {
              <div class="flex justify-content-end mt-3"><p-button label="Confirm return receipt" icon="pi pi-check"
                [loading]="returnBusy" (click)="receiveReturn(request)"></p-button></div>
            }
          </div>
        }
      </section>
    }

    @if (notices.length) {
      <section class="warehousing-table-card">
        <div class="warehousing-table-header">
          <div><h2>Inbound transfer notices</h2>
            <p>Compare dispatched quantities with the physical count at each destination warehouse.</p></div>
          <span class="warehousing-result-chip">{{ notices.length }} notices</span>
        </div>
        <div class="flex flex-wrap gap-2 px-3 pb-3">
          @for (notice of notices; track notice.id) {
            <p-button [label]="noticeWarehouseLabel(notice.destinationWarehouseId) + ' · ' + notice.status"
              [outlined]="selectedNoticeId !== notice.id" size="small" (click)="selectNotice(notice.id)"></p-button>
          }
        </div>
        @if (selectedNotice(); as notice) {
          <div class="px-3 pb-3">
            <div class="flex flex-wrap align-items-center gap-3 mb-3">
              <p-tag [value]="notice.status" [severity]="notice.status === 'EXCEPTION' ? 'danger' :
                notice.status === 'VERIFIED' ? 'success' : 'info'"></p-tag>
              <span>Expected <strong>{{ formatQty(notice.expected) }}</strong></span>
              <span>Received <strong>{{ formatQty(notice.received) }}</strong></span>
              <span>Revision <strong>{{ notice.revision }}</strong></span>
              @if (canReceiveNotice() && notice.status === 'ANNOUNCED') {
                <p-button label="Mark arrived" icon="pi pi-map-marker" size="small" [loading]="noticeBusy"
                  (click)="markNoticeArrived()"></p-button>
              }
            </div>
            <p-table [value]="notice.groups" styleClass="p-datatable-sm warehousing-data-table"
              [tableStyle]="{ 'min-width': '62rem' }">
              <ng-template pTemplate="header"><tr><th>Item / owner / lot</th><th>Source</th><th>Expected</th>
                <th>Received</th><th>Physical count</th><th>Identified units (UNIT tracking)</th></tr></ng-template>
              <ng-template pTemplate="body" let-group><tr>
                <td><strong>{{ itemLabel(group) }}</strong><br><small>{{ group.trackingMode }} · {{ group.ownerType }}
                  · Lot {{ group.lotId || '—' }} · {{ conditionLabel(group.conditionId) }}</small></td>
                <td>{{ warehouseLabel(group.sourceWarehouseId) }}</td>
                <td>{{ formatQty(group.expected) }}</td><td>{{ formatQty(group.received) }}</td>
                <td><input type="number" min="0" step="0.0001" pInputText [(ngModel)]="countDraft[group.key]"
                  [disabled]="!canReceiveNotice() || notice.status === 'VERIFIED'" style="width:8rem"></td>
                <td>
                  @if (group.trackingMode === 'UNIT' || group.trackingMode === 'UNIQUE_ASSET') {
                    <textarea rows="2" [(ngModel)]="codeDraft[group.key]" placeholder="One internal unit code per line"
                      [disabled]="!canReceiveNotice() || notice.status === 'VERIFIED'"></textarea>
                  } @else { <span class="cell-meta">Quantity count</span> }
                </td>
              </tr></ng-template>
            </p-table>
            @if (canReceiveNotice() && notice.status !== 'VERIFIED' && notice.status !== 'ANNOUNCED') {
              <div class="flex flex-wrap align-items-end gap-2 mt-3">
                <p-button label="Save final count" icon="pi pi-save" severity="secondary" [outlined]="true"
                  [loading]="noticeBusy" (click)="saveNoticeCounts()"></p-button>
                <p-select [options]="noticeZones()" optionLabel="name" optionValue="id" [(ngModel)]="noticeZoneId"
                  placeholder="Destination receipt zone" appendTo="body" styleClass="w-16rem"></p-select>
                <input pInputText [(ngModel)]="noScanReason" placeholder="Reason for no-scan confirmation"
                  style="min-width:18rem" />
                <p-button label="Confirm counted receipts" icon="pi pi-check" [loading]="noticeBusy"
                  [disabled]="!noticeZoneId || !noScanReason.trim() || notice.finalCountRevision !== notice.revision"
                  (click)="confirmNotice()"></p-button>
                <p-button label="Verify" icon="pi pi-verified" severity="success" [outlined]="true"
                  [loading]="noticeBusy" [disabled]="notice.finalCountRevision !== notice.revision"
                  (click)="verifyNotice()"></p-button>
              </div>
            }
            @if (notice.exceptions.length) {
              <h3 class="mt-4">Count exceptions</h3>
              @for (exception of notice.exceptions; track exception.id) {
                <div class="flex flex-wrap align-items-center gap-3 py-2 border-bottom-1 surface-border">
                  <p-tag [value]="exception.kind" severity="danger"></p-tag>
                  <strong>{{ formatQty(exception.quantity) }}</strong>
                  <span>{{ noticeGroupLabel(exception.groupKey) }}</span>
                  <p-tag [value]="exception.status" [severity]="exception.status === 'RESOLVED' ? 'success' : 'warn'"></p-tag>
                  @if (exception.status === 'OPEN' && canResolveNotice()) {
                    <p-button label="Resolve" size="small" severity="secondary" [outlined]="true"
                      (click)="resolveNoticeException(exception)"></p-button>
                  }
                </div>
              }
            }
            <details class="mt-3">
              <summary>Notice audit history ({{ notice.events.length }})</summary>
              <div class="mt-2">
                @for (event of notice.events; track event.id) {
                  <div class="py-2 border-bottom-1 surface-border">
                    <strong>{{ event.eventType }}</strong> · Revision {{ event.revision }} ·
                    {{ event.createdAt | date:'medium':'UTC' }}
                    @if (event.actorId) { · User #{{ event.actorId }} }
                    @if (event.reason) { <span class="block">{{ event.reason }}</span> }
                  </div>
                }
              </div>
            </details>
          </div>
        }
      </section>
    }

    <p-dialog header="Resolve inbound exception" [visible]="!!resolvingException"
      (visibleChange)="!$event && (resolvingException = undefined)" [modal]="true"
      [style]="{ width: 'min(540px, 96vw)' }">
      @if (resolvingException) {
        <p>{{ resolvingException.kind }} of {{ formatQty(resolvingException.quantity) }}.
          This action records a stock adjustment with an audit trail.</p>
        @if (resolvingException.kind === 'EXTRA') {
          <p>Choose a destination zone for the separate stock entry.</p>
          <p-select [options]="noticeZones()" optionLabel="name" optionValue="id" [(ngModel)]="noticeZoneId"
            placeholder="Destination zone" appendTo="body" styleClass="w-full"></p-select>
        }
        <textarea rows="3" class="w-full mt-3" [(ngModel)]="resolutionReason"
          placeholder="Resolution reason"></textarea>
      }
      <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [outlined]="true"
          (click)="resolvingException = undefined"></p-button>
        <p-button label="Approve resolution" [disabled]="!resolutionReason.trim() ||
          (resolvingException?.kind === 'EXTRA' && !noticeZoneId)" [loading]="noticeBusy"
          (click)="submitNoticeResolution()"></p-button>
      </ng-template>
    </p-dialog>

    <section class="warehousing-table-card">
      <div class="warehousing-table-header">
        <div>
          <h2>Shipment Warehouse Work</h2>
          <p>Transfers are shown before final dispatches. Dispatches use reverse stop sequence for loading.</p>
        </div>
        <span class="warehousing-result-chip">{{ visibleRows().length }} work rows</span>
      </div>

      @if (workDirection === 'OUTBOUND') {
        <div class="desktop-work-guide">
          <strong>Confirm without scanning</strong>
          <span>1. Select work &nbsp;→&nbsp; 2. Reserve Stock &nbsp;→&nbsp; 3. Confirm Pick &nbsp;→&nbsp; 4. Confirm Stage &nbsp;→&nbsp; 5. Confirm Load &nbsp;→&nbsp; 6. Dispatch</span>
          <small>Reserve assigns available stock to the document. Review and give a reason at each step. Stock stays on hand until Dispatch Transfer or Confirm Dispatch Exit posts it out.</small>
          <small>For stock still in transit, open the document and choose its incoming transfer as supply. Picking waits until receipt.</small>
        </div>
      }

      @if (work.selectedDeliveryNumber) {
        <div class="px-3 py-2 text-700">Showing only work linked to delivery <strong>{{ work.selectedDeliveryNumber }}</strong>.</div>
      }
      <div class="px-3 py-2">
        <label><input type="checkbox" [(ngModel)]="showCompleted"> Show completed linked work</label>
      </div>
      <div class="bulk-bar flex flex-wrap align-items-end gap-2">
        <p-button label="Select same type and warehouse across all pages" icon="pi pi-check-square" severity="secondary" [outlined]="true"
          [disabled]="!selectedRows().length"
          (click)="selectMatchingGroup()"></p-button>
        <p-button label="Clear selection" icon="pi pi-times" severity="secondary" [text]="true"
          [disabled]="!selectedRows().length" (click)="clearRowSelection()"></p-button>
        <span class="font-semibold mr-2">{{ selectedRows().length }} selected</span>
        @if (selectedRows().length) {
          <p-select [options]="bulkActions()" optionLabel="label" optionValue="value" [(ngModel)]="bulkAction"
            placeholder="Choose action" appendTo="body" styleClass="w-14rem"></p-select>
          @if (bulkAction === 'TRANSFER_RECEIVE') {
            <p-select [options]="receiptZones()" optionLabel="name" optionValue="id"
              [(ngModel)]="selectedReceiptZoneId" placeholder="Destination zone if needed"
              [showClear]="true" appendTo="body" styleClass="w-16rem"></p-select>
          }
          <p-button label="Review selected step" icon="pi pi-eye" [loading]="isBulkBusy"
            [disabled]="isBulkBusy" (click)="previewBulk()"></p-button>
        }
      </div>

      <p-table [value]="visibleRows()" dataKey="documentId" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table"
        [paginator]="visibleRows().length > 25" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]"
        [tableStyle]="{ 'min-width': '76rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem;">Select</th>
            <th style="width: 8rem;">Load</th>
            <th>Document</th>
            <th>Route</th>
            <th>Warehouse Flow</th>
            <th>Items &amp; quantities</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td><input type="checkbox" [checked]="isSelected(row)" [disabled]="!isOpen(row)"
              [attr.aria-label]="'Select ' + row.documentNumber"
              (change)="toggleRow(row, $any($event.target).checked)"></td>
            <td>
              <span class="work-order-badge">{{ row.routeLoadSequence || '-' }}</span>
            </td>
            <td>
              <div class="work-document">
                <i [class]="documentIcon(row)"></i>
                <div class="stack-cell">
                  <span class="warehousing-code-pill">{{ row.documentNumber || '-' }}</span>
                  <span class="cell-meta">{{ row.documentType }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ row.transportReleaseNumber || 'No release' }}</span>
                <span class="cell-meta"><i class="pi pi-sort-numeric-down"></i> Stop {{ row.routeStopSequence || '-' }}</span>
                @if (row.deliveryNumber) {
                  <span class="cell-meta"><i class="pi pi-map-marker"></i> {{ row.deliveryNumber }}</span>
                }
                @if (row.crossDockOrchestrationNumber) {
                  <span class="cell-meta"><i class="pi pi-sitemap"></i> {{ row.crossDockOrchestrationNumber }}</span>
                }
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ flowLabel(row) }}</span>
                @if (row.gatedByTransferId) {
                  <span class="cell-meta"><i class="pi pi-lock"></i> Gated by transfer {{ row.gatedByTransferId }}
                    ({{ row.gatedByTransferStatus || 'unknown' }})</span>
                }
                <span class="cell-meta"><i class="pi pi-list"></i> {{ row.lineCount || 0 }} lines</span>
              </div>
            </td>
            <td>
              <div class="work-items">
                <span class="work-items-total">Total: {{ quantitySummary(row) }}</span>
                @for (line of row.lines || []; track line.lineId || $index) {
                  <div class="work-item-line">
                    <strong>{{ workLineLabel(line) }}</strong>
                    @if (line.warehouseLabel || line.warehouseId) {
                      <span class="cell-meta">{{ line.warehouseLabel || 'Warehouse ID ' + line.warehouseId }}</span>
                    }
                    <span class="cell-meta">Req {{ formatQty(line.quantityRequested) }} · Res {{ formatQty(line.quantityReserved) }} · Out {{ formatQty(line.quantityOutbound) }}
                      @if (row.documentType === 'TRANSFER') { · In {{ formatQty(line.quantityReceived) }} }
                    </span>
                  </div>
                } @empty {
                  <span class="cell-meta">No item lines</span>
                }
              </div>
            </td>
            <td>
              <p-tag [value]="row.status || '-'" [severity]="statusSeverity(row.status)"></p-tag>
            </td>
            <td class="text-center">
              <div class="warehousing-row-actions">
                <p-button icon="pi pi-eye" [text]="true" [routerLink]="detailLink(row)" [queryParams]="workQueryParams()"></p-button>
                @if (canChooseSupplyRow(row)) {
                  <p-button label="Reserve supply" icon="pi pi-box" size="small" severity="secondary" [outlined]="true"
                    [routerLink]="detailLink(row)" [queryParams]="supplyQueryParams()"></p-button>
                }
                <p-button label="Scan" icon="pi pi-barcode" size="small" severity="secondary" [outlined]="true"
                  [routerLink]="scanLink(row)" [queryParams]="workQueryParams()"></p-button>
                <p-button icon="pi pi-history" [text]="true" severity="secondary" (click)="showHistory(row)"></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">
              <div class="warehousing-empty-state">
                <i class="pi pi-inbox"></i>
                <strong>No warehouse work linked</strong>
                <span>This shipment has no linked dispatch or transfer records yet.</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>

    <p-dialog header="Review bulk work" [(visible)]="bulkDialogVisible" [modal]="true"
      [style]="{ width: 'min(1120px, 96vw)' }" [breakpoints]="{ '860px': '96vw' }"
      [draggable]="false" [resizable]="false" styleClass="bulk-review-dialog">
      @if (bulkPreview) {
        <section class="bulk-review-layout">
          <aside class="bulk-review-summary">
            <div class="bulk-review-icon"><i class="pi pi-clipboard"></i></div>
            <div>
              <small>WAREHOUSE ACTION</small>
              <h3>{{ bulkActionLabel() }}</h3>
              <p>{{ bulkAction === 'TRANSFER_DISPATCH' || bulkAction === 'DISPATCH_EXIT'
                ? 'This confirmation posts stock out of the source warehouse.'
                : bulkAction === 'RESERVE'
                  ? 'Assign available stock to these documents. Stock remains on hand; exact units are selected on confirmation.'
                  : 'Confirm this step without individual barcode scans. Stock remains on hand.' }}</p>
            </div>
            <div class="bulk-review-facts">
              <div><span>Shipment</span><strong>{{ work.shipmentNumber || '-' }}</strong></div>
              <div><span>Warehouse</span><strong>{{ warehouseLabel(bulkPreview.rows.length ? bulkPreview.rows[0].warehouseId : undefined) }}</strong></div>
              <div><span>Selected</span><strong>{{ bulkPreview.rows.length }}</strong></div>
              <div><span>Ready</span><strong class="bulk-ready-count">{{ bulkPreview.eligibleCount }}</strong></div>
              <div><span>Blocked</span><strong [class.bulk-blocked]="bulkPreview.blockedCount">{{ bulkPreview.blockedCount }}</strong></div>
            </div>
          </aside>

          <div class="bulk-review-content">
            @if (bulkPreview.blockedCount) {
              <div class="bulk-review-alert" role="alert">
                <i class="pi pi-exclamation-triangle"></i>
                <div>
                  <strong>{{ bulkPreview.blockedCount }} {{ bulkPreview.blockedCount === 1 ? 'document needs' : 'documents need' }} attention</strong>
                  <span>Resolve these issues, then create a fresh preview.</span>
                  @for (blocker of bulkBlockers; track $index) {
                    <div class="bulk-review-blocker">
                      <span>
                        @if (blocker.blockingDocument; as pending) {
                          {{ pending.documentType === 'TRANSFER' ? 'Transfer' : 'Dispatch' }}
                          <a class="bulk-blocker-link" [routerLink]="blockingDocumentLink(pending)"
                            [queryParams]="workQueryParams()">{{ pending.documentNumber }}</a>
                          is still {{ pending.status }} and blocks this load. Review or resolve it, then preview again.
                        } @else { {{ blocker.reason }} }
                      </span>
                      <b>{{ blocker.count }}</b>
                    </div>
                  }
                </div>
              </div>
            }

            <div class="bulk-review-section-heading">
              <div><small>SELECTED WORK</small><h4>{{ bulkAction === 'RESERVE' ? 'Documents and requested quantities' : 'Documents and stock units' }}</h4></div>
              <span>{{ bulkPreview.rows.length }} rows</span>
            </div>
            <div class="bulk-preview-list">
              <p-table [value]="bulkPreview.rows" [scrollable]="true" scrollHeight="20rem"
                [tableStyle]="{ 'min-width': '42rem' }" styleClass="p-datatable-sm bulk-review-table">
                <ng-template pTemplate="header">
                  <tr><th>Document</th><th>State</th><th>Stock units</th><th>Quantity</th><th>Result</th></tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                  <tr>
                    <td><strong class="bulk-document-number">{{ item.documentNumber }}</strong></td>
                    <td><p-tag [value]="item.status" [severity]="statusSeverity(item.status)"></p-tag></td>
                    <td>
                      @if (bulkAction === 'RESERVE' && !item.units.length) {
                        <span>Assigned on confirmation</span>
                      }
                      @for (unit of item.units; track unit.reservationId) {
                        <div class="bulk-unit-detail">
                          <strong>#{{ unit.stockUnitId }}</strong>
                          <span>{{ unit.quantity }} &middot; {{ unit.outboundState || 'PENDING' }}
                            @if (unit.receiptState) { / {{ unit.receiptState }} }</span>
                        </div>
                      }
                    </td>
                    <td>{{ item.quantity }}</td>
                    <td>
                      <span class="bulk-result" [class.bulk-result-blocked]="item.blockedReason">
                        <i [class]="item.blockedReason ? 'pi pi-exclamation-circle' : 'pi pi-check-circle'"></i>
                        @if (item.blockingDocument; as pending) {
                          <span>{{ pending.documentType === 'TRANSFER' ? 'Transfer' : 'Dispatch' }}
                            <a class="bulk-blocker-link" [routerLink]="blockingDocumentLink(pending)"
                              [queryParams]="workQueryParams()">{{ pending.documentNumber }}</a>
                            is still {{ pending.status }} and blocks this load.</span>
                        } @else {
                          {{ item.blockedReason || (bulkAction === 'RESERVE' ? 'Ready to reserve; stock checked on confirmation' : 'Ready') }}
                        }
                      </span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            @if (!bulkPreview.blockedCount) {
              <div class="bulk-review-reason">
                <label for="bulkReason">Reason for {{ bulkAction === 'RESERVE' ? 'reservation' : 'no-scan confirmation' }} <span>*</span></label>
                <p>{{ bulkAction === 'RESERVE' ? 'Record why these documents are being reserved.' : 'Record why this work is being confirmed without individual scans.' }}</p>
                <textarea id="bulkReason" rows="3" [(ngModel)]="bulkReason"
                  placeholder="Enter the operator confirmation reason"></textarea>
              </div>
            }
          </div>
        </section>
      }
      <ng-template pTemplate="footer">
        <div class="bulk-review-footer">
          <span>{{ bulkPreview?.blockedCount ? 'Resolve blocked work before confirmation' : 'Operator confirmation will be recorded' }}</span>
          <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
            (click)="bulkDialogVisible = false"></p-button>
          <p-button label="Confirm selected work" icon="pi pi-check" [loading]="isBulkBusy"
            [disabled]="isBulkBusy || !bulkPreview || !!bulkPreview.blockedCount || !bulkReason.trim()"
            (click)="commitBulk()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog [header]="historyTitle" [(visible)]="historyDialogVisible" [modal]="true"
      [style]="{ width: 'min(900px, 96vw)' }" [draggable]="false">
      <p-table [value]="historyRows" [paginator]="historyRows.length > 15" [rows]="15" styleClass="p-datatable-sm">
        <ng-template pTemplate="header"><tr><th>UTC Time</th><th>Action</th><th>Status</th><th>Method</th><th>Unit</th><th>Change</th><th>Actor</th><th>Reason / Failure</th><th>Batch</th></tr></ng-template>
        <ng-template pTemplate="body" let-event><tr>
          <td>{{ event.occurredAt | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}</td><td>{{ event.action }}</td>
          <td>{{ event.status }}</td><td>{{ methodLabel(event.method) }}</td>
          <td>{{ event.stockUnitId || '-' }}</td><td>{{ event.beforeState || '-' }} &rarr; {{ event.afterState || '-' }}</td>
          <td>{{ event.actorId }}</td><td>{{ event.reason || '-' }}<br *ngIf="event.failure"><small>{{ event.failure }}</small></td>
          <td><small>{{ event.batchId }}<br *ngIf="event.correlationId">{{ event.correlationId }}</small></td>
        </tr></ng-template>
        <ng-template pTemplate="emptymessage"><tr><td colspan="9">No new-format work events yet. Earlier actions remain legacy records.</td></tr></ng-template>
      </p-table>
    </p-dialog>

    <section class="warehousing-table-card">
      <div class="warehousing-table-header">
        <div>
          <h2>Shipment Attachments</h2>
          <p>Shipment, delivery, and delivery-stop files available to the warehouse team.</p>
        </div>
        <span class="warehousing-result-chip">{{ work.attachments.length }} files</span>
      </div>

      @if (work.attachments.length) {
        <div class="attachment-grid">
          @for (file of work.attachments; track file.attachmentId || file.fileUrl) {
            <div class="attachment-tile">
              @if (file.fileUrl) {
                <app-attachment-preview [url]="file.fileUrl" [name]="file.fileName || 'Attachment'"></app-attachment-preview>
              } @else {
                <span class="attachment-missing-preview"><i class="pi pi-file"></i></span>
              }
              <div class="attachment-details">
                @if (file.fileUrl) {
                  <a [href]="file.fileUrl" target="_blank" rel="noopener"><strong>{{ file.fileName || 'Attachment' }}</strong></a>
                } @else {
                  <strong>{{ file.fileName || 'Attachment' }}</strong>
                }
                <span class="cell-meta">{{ attachmentSubtitle(file) }}</span>
                @if (file.createdAt) { <small class="cell-meta">{{ file.createdAt | date:'mediumDate' }}</small> }
                <div class="attachment-scope" [class.shipment-level]="file.scope === 'SHIPMENT'">
                  <i [class]="attachmentScopeIcon(file)"></i>
                  <div>
                    <strong>{{ attachmentScopeLabel(file) }}</strong>
                    @if (file.transportReleaseNumber) { <span>{{ file.transportReleaseNumber }}</span> }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="warehousing-empty-state">
          <i class="pi pi-paperclip"></i>
          <strong>No attachments found</strong>
          <span>This shipment does not have shipment or delivery files yet.</span>
        </div>
      }
    </section>
  }
</div>
